import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2024 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { useState } from "react";
import { RSForm } from "../index";
import { Checkbox, CheckboxGroup } from "rsuite"; // @ts-ignore
function FormCheckboxes(props) {
    const { id, label, checkboxConfig, inline, indeterminate, hidden, defaultChecked = [], } = props;
    const [checkedItems, setCheckedItems] = useState(defaultChecked);
    const handleCheckboxChange = (value) => {
        const updatedCheckedItems = checkedItems.includes(value)
            ? checkedItems.filter((item) => item !== value)
            : [...checkedItems, value];
        setCheckedItems(updatedCheckedItems);
        props.setCheckedItems(updatedCheckedItems);
    };
    return (_jsx("div", { style: { display: hidden ? "none" : "block" }, children: _jsxs(RSForm.Group, { controlId: id, children: [label && _jsx(RSForm.ControlLabel, { children: label }), _jsx(CheckboxGroup, { id: id, name: `${id}-checkbox-group`, value: checkedItems, inline: inline, children: checkboxConfig.fields.map((field, index) => (_jsx("div", { style: field.style, children: _jsx(Checkbox, { value: field.value, indeterminate: indeterminate, name: `checkbox${index}`, defaultChecked: field.defaultChecked, disabled: field.disabled, onChange: () => handleCheckboxChange(field.value), children: _jsxs("div", { style: { display: "flex", flexDirection: "column" }, children: [field.children, field.subtext && (_jsxs("span", { className: "rs-form-help-text", children: [_jsxs("span", { style: { color: "red", marginLeft: "10px" }, children: ["*", " "] }), field.subtext] }))] }) }, index) }, index))) })] }) }));
}
export default FormCheckboxes;
